/** Semantic button color variants aligned with application theme. */
export enum ButtonVariant {
  Primary = 'primary',
  Secondary = 'secondary',
  Success = 'success',
  Danger = 'danger',
  Warning = 'warning',
  Info = 'info',
  Outline = 'outline',
}

/** Button size scale. */
export enum ButtonSize {
  Xs = 'xs',
  Sm = 'sm',
  Md = 'md',
  Lg = 'lg',
}

/** Native HTML button type attribute. */
export type ButtonHtmlType = 'button' | 'submit' | 'reset';

/** Input contract for programmatic configuration or wrappers. */
export interface AppButtonConfig {
  label?: string;
  type?: ButtonHtmlType;
  variant?: ButtonVariant | string;
  size?: ButtonSize | string;
  disabled?: boolean;
  loading?: boolean;
  iconLeft?: string;
  iconRight?: string;
  fullWidth?: boolean;
  active?: boolean;
  customClass?: string;
  ariaLabel?: string;
  title?: string;
  compatBootstrap?: boolean;
}
